import { HttpParams } from "@angular/common/http";
import { PaginationFilter } from "./pagination.types";
import { PAGINATION_KEYS } from "./pagination.constants";

export function getPaginationParams(filter: PaginationFilter) {
    let params = new HttpParams()
        .set('pageNumber', filter.pageNumber.toString())
        .set('pageSize', filter.pageSize.toString());

    if (filter.search) {
        params = params.set('search', filter.search.replace('/', ''));
    }

    if (filter.sortBy) {
        params = params.set('sortBy', filter.sortBy);
    }

    if (filter.sortDirection) {
        params = params.set('sortDirection', filter.sortDirection);
    }

    return params;
};

export function setFilter(filter: PaginationFilter, key: string): void {
    sessionStorage.setItem(`${PAGINATION_KEYS.FILTER}-${key}`, JSON.stringify(filter));
}

export function getFilter(key: string): PaginationFilter {
    const filter = sessionStorage.getItem(`${PAGINATION_KEYS.FILTER}-${key}`);

    return filter ? JSON.parse(filter) : {
        pageNumber: 1,
        pageSize: 10,
        search: null,
        sortBy: null,
        sortDirection: null
    };
}